// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.monomer-manager-root .grok-sketcher {
    min-width: unset !important;
}

.monomer-manager-root {
    width: 100% !important;
    height: 100% !important;
}

.monomer-manager-sketcher .ketcher-host {
    height: 100% !important;
    width: unset !important;
} 

.monomer-manager-root > div:first-child {
    flex-basis: 40% !important;
}
.monomer-manager-root > div:nth-child(2) {
    flex-basis: 60% !important;
}

.monomer-manager-root > div:first-child > .ui-form {
    max-width: unset !important;
}

.monomer-card-info-row {
    width: 100%;
    overflow: hidden;
    text-overflow: ellipsis;
    margin-bottom: 10px;
}

.monomer-card-info-row > div:nth-child(2) {
    white-space: nowrap;
    overflow: hidden;
    text-overflow: ellipsis;
}

.monomer-card-info-row > div:nth-child(1) {
    font-weight: bold;
    margin-right: 5px;
    text-wrap: nowrap;
}

.duplicate-monomer-symbol-row {
    visibility: visible !important;
}

.monomer-card-root {
    border: 2px solid var(--grey-2);
    border-radius: 5px;
    padding: 5px;
    margin: 5px;
    overflow: hidden;
    align-items: center;
    cursor: pointer;
    width: 200px;
    height: 300px;
    min-width: 200px;
    min-height: 300px;
}

.duplicate-monomers-virtual-view {
    width: 100% !important;
    overflow-x: clip;
    overflow-y: auto;
}

.monomer-manager-form-tab-control input.d4-invalid {
    background: #ff000030;
}

.monomer-lib-controls-form .ui-input-root {
    flex-wrap: nowrap !important;
}`, "",{"version":3,"sources":["webpack://./css/monomer-manager.css"],"names":[],"mappings":"AAAA;IACI,2BAA2B;AAC/B;;AAEA;IACI,sBAAsB;IACtB,uBAAuB;AAC3B;;AAEA;IACI,uBAAuB;IACvB,uBAAuB;AAC3B;;AAEA;IACI,0BAA0B;AAC9B;AACA;IACI,0BAA0B;AAC9B;;AAEA;IACI,2BAA2B;AAC/B;;AAEA;IACI,WAAW;IACX,gBAAgB;IAChB,uBAAuB;IACvB,mBAAmB;AACvB;;AAEA;IACI,mBAAmB;IACnB,gBAAgB;IAChB,uBAAuB;AAC3B;;AAEA;IACI,iBAAiB;IACjB,iBAAiB;IACjB,iBAAiB;AACrB;;AAEA;IACI,8BAA8B;AAClC;;AAEA;IACI,+BAA+B;IAC/B,kBAAkB;IAClB,YAAY;IACZ,WAAW;IACX,gBAAgB;IAChB,mBAAmB;IACnB,eAAe;IACf,YAAY;IACZ,aAAa;IACb,gBAAgB;IAChB,iBAAiB;AACrB;;AAEA;IACI,sBAAsB;IACtB,gBAAgB;IAChB,gBAAgB;AACpB;;AAEA;IACI,qBAAqB;AACzB;;AAEA;IACI,4BAA4B;AAChC","sourcesContent":[".monomer-manager-root .grok-sketcher {\n    min-width: unset !important;\n}\n\n.monomer-manager-root {\n    width: 100% !important;\n    height: 100% !important;\n}\n\n.monomer-manager-sketcher .ketcher-host {\n    height: 100% !important;\n    width: unset !important;\n} \n\n.monomer-manager-root > div:first-child {\n    flex-basis: 40% !important;\n}\n.monomer-manager-root > div:nth-child(2) {\n    flex-basis: 60% !important;\n}\n\n.monomer-manager-root > div:first-child > .ui-form {\n    max-width: unset !important;\n}\n\n.monomer-card-info-row {\n    width: 100%;\n    overflow: hidden;\n    text-overflow: ellipsis;\n    margin-bottom: 10px;\n}\n\n.monomer-card-info-row > div:nth-child(2) {\n    white-space: nowrap;\n    overflow: hidden;\n    text-overflow: ellipsis;\n}\n\n.monomer-card-info-row > div:nth-child(1) {\n    font-weight: bold;\n    margin-right: 5px;\n    text-wrap: nowrap;\n}\n\n.duplicate-monomer-symbol-row {\n    visibility: visible !important;\n}\n\n.monomer-card-root {\n    border: 2px solid var(--grey-2);\n    border-radius: 5px;\n    padding: 5px;\n    margin: 5px;\n    overflow: hidden;\n    align-items: center;\n    cursor: pointer;\n    width: 200px;\n    height: 300px;\n    min-width: 200px;\n    min-height: 300px;\n}\n\n.duplicate-monomers-virtual-view {\n    width: 100% !important;\n    overflow-x: clip;\n    overflow-y: auto;\n}\n\n.monomer-manager-form-tab-control input.d4-invalid {\n    background: #ff000030;\n}\n\n.monomer-lib-controls-form .ui-input-root {\n    flex-wrap: nowrap !important;\n}"],"sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
